import { Picker, TextField, View, Item, Flex, Heading, Button, Image } from '@adobe/react-spectrum';
import styles from '../../../../styles.module.scss';
import { useState } from 'react';
import { monthOptions, yearOptions } from '../../../../globalContant';

const Filters = () => {
  const [filters, setFilters] = useState({
    admissionId: '',
    month: '',
    year: '',
  });

  const handleChange = (key: string, value: string) => {
    setFilters({
      ...filters,
      [key]: value,
    });
  };

  const handleClearFilter = () => {
    setFilters({
      admissionId: '',
      month: '',
      year: '',
    });
  };

  return (
    <View UNSAFE_className={styles.card} marginTop={'size-100'}>
      <Flex gap={'size-150'}>
        <Image width={22} height={22} src={'/images/filter.png'} alt="File preview" objectFit="contain" />
        <Heading level={4} marginTop={'size-0'}>
          Filters
        </Heading>
      </Flex>
      <Flex width="100%" justifyContent={'space-between'} wrap={'wrap'}>
        <TextField
          width={'33%'}
          label="Admission Id"
          value={filters.admissionId}
          onChange={(value) => {
            const numericValue = value.replace(/\D/g, '').slice(0, 12);
            handleChange('admissionId', numericValue);
          }}
          maxLength={15}
        />
        <Picker
          width={'33%'}
          label="Month"
          items={monthOptions}
          selectedKey={filters.month}
          onSelectionChange={(value) => handleChange('month', value as string)}
        >
          {(item) => <Item key={item.name}>{item.name}</Item>}
        </Picker>
        <Picker width={'33%'} label="Year" items={yearOptions} selectedKey={filters.year} onSelectionChange={(key) => handleChange('year', key as string)}>
          {(item) => <Item key={item.name}>{item.name}</Item>}
        </Picker>
      </Flex>
      <Flex justifyContent={'end'} marginTop={'size-200'} gap={'size-100'}>
        <Button width="size-2000" variant="primary" onPress={handleClearFilter}>
          Clear
        </Button>
        <Button width="size-2000" variant="cta">
          Search
        </Button>
      </Flex>
    </View>
  );
};

export default Filters;
